import React, { useState, useEffect, useRef } from 'react';
import Logo from '../../assets/img/logo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons'
import './styles.css';

import { menuData } from '../../utils/datas';

export default function NavBar({ handleAnchor }) {
    const navBarMobile = useRef(null);
    const imageMobile = useRef(null);
    const menuDesktop = useRef(null);
    const menuMobile = useRef(null);
    const menuMobileList = useRef(null);


    useEffect(() => {
        function handleSize(e) {
            let currentWitdh;
            currentWitdh = e.currentTarget.innerWidth;

            if (currentWitdh < 780) {
                navBarMobile.current.style.justifyContent = "space-between";
                imageMobile.current.classList.add('d-show');
                imageMobile.current.classList.remove('d-hide');
                menuDesktop.current.classList.add('d-hide');
                menuMobile.current.classList.remove('d-hide');
                menuMobile.current.classList.add('d-show');
            } else {
                navBarMobile.current.style.justifyContent = "center";
                imageMobile.current.classList.remove('d-show');
                imageMobile.current.classList.add('d-hide');
                menuDesktop.current.classList.remove('d-hide');
                menuDesktop.current.classList.add('d-showDesktop');
                menuMobile.current.classList.add('d-hide');
                menuMobile.current.classList.remove('d-show');
            }
        }
        window.addEventListener('resize', handleSize);

    }, [])

    useEffect(() => {
        let currentWitdh;
        currentWitdh = window.innerWidth;

        if (currentWitdh < 780) {
            navBarMobile.current.style.justifyContent = "space-between";
            imageMobile.current.classList.add('d-show');
            imageMobile.current.classList.remove('d-hide');
            menuDesktop.current.classList.add('d-hide');
            menuMobile.current.classList.remove('d-hide');
            menuMobile.current.classList.add('d-show');
        }

    }, [])

    function handleMenuMobile() {
        menuMobileList.current.classList.toggle('d-show');
    }


    return (
        <>
            <div className="navBar" ref={navBarMobile}>
                <a href="/" className="d-hide" ref={imageMobile}>
                    <img src={Logo} />
                </a>
                <ul className="menu" ref={menuDesktop}>
                    {menuData.map(m => (
                        <li key={m.id.toString()} className="menu-item">
                            {m.imagem && <img src={Logo} />}
                            <a onClick={() => handleAnchor(m.href)}>{m.title}</a>
                        </li>
                    ))}
                </ul>

                <div className="menu-hamburguer d-hide" ref={menuMobile} onClick={handleMenuMobile}>
                    <FontAwesomeIcon icon={faBars} size="2x" color="#eee" />
                </div>

            </div>

            <div className="menu-mobile d-hide" ref={menuMobileList}>
                <ul>
                    {menuData.map(m => (
                        <li key={m.id.toString()} className="menu-item">
                            <a onClick={() => handleAnchor(m.href)}>{m.title}</a>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    )
}